import React, { FunctionComponent } from "react";

import { TranslationSet } from "../../db/models/Question";
import { useLanguage } from "../translation/frontend";

interface Props {
  translations?: TranslationSet;
}

export function translateDbString(translations: TranslationSet | void, language: string) {
  if (!translations) {
    return null;
  }
  return translations.find((translation) => translation.language === language)?.text ?? null;
}

export const Translated: FunctionComponent<Props> = ({ translations, children }) => {
  const language = useLanguage();
  return <>{translateDbString(translations, language) ?? children ?? null}</>;
};
